<template>
  <div id="news">
    <page-not-ready />
  </div>
</template>

<script>
export default {
  name: 'News',
  metaInfo: {
    title: 'News'
  }
}
</script>
